import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { GetDependencyConfidenceResponse } from '../../../../shared/types/routes/binary';

const getReleaseDependencyConfidencesQueryKey = (
  releaseId: number,
): QueryKey => ['binary', 'release', releaseId, 'dependency-confidence'].filter(Boolean);

function getReleaseDependencyConfidences(releaseId: number) {
  const baseUrl = `/api/binary/release/${releaseId}/dependency-confidence`;
  return get<GetDependencyConfidenceResponse>(baseUrl);
}

/**
 * Helper hook for fetching the confidence of the dependencies of a user's project group release.
 * @param releaseId - The revision locator of the user's revision.
 * @param shouldFetch - default true, allows hook to be skipped when project not available.
 * @returns A query for the confidence of the revision's dependencies.
 */
export default function useGetReleaseDependencyConfidences(
  releaseId: number,
  shouldFetch = true,
) {
  return useQuery<GetDependencyConfidenceResponse>({
    queryFn: () => getReleaseDependencyConfidences(releaseId),
    queryKey: getReleaseDependencyConfidencesQueryKey(releaseId),
    enabled: shouldFetch,
  });
}
